/* eslint-disable */

import ICON_MAIL from '../../assets/images/icon_mail.svg';
import ICON_PHONE from '../../assets/images/icon_phone.svg';
import ICON_PIN from '../../assets/images/icon_pin.svg';
import ICON_SUPPORT from '../../assets/images/icon_support.svg';
import ICON_LINE from '../../assets/images/icon_line.svg';
import './NewFooter.css';

const NewFooter = (props) => {
  const renderLink = (title) => {
    return (
      <button
        className="footer-link-btn"
        onClick={() => {
          if (props.callback_popup_signin) {
            props.callback_popup_signin();
          }
        }}>
        {title}
      </button>
    )
  }

  return (
    <footer className='footer-wrapper'>
      <div className='footer-content'>
        <div className='footer-col brand-col'>
          <h2 className='footer-brand'>มียา.com</h2>
          <p className='footer-tagline'>
            แพลตฟอร์มตลาดยาออนไลน์<br />
            สะดวก รวดเร็ว ปลอดภัย
          </p>
        </div>

        <div className='footer-col links-col'>
          <h3 className='footer-heading'>เมนูหลัก</h3>
          <div className='footer-links'>
            {renderLink('หน้าแรก')}
            {renderLink('ขายสินค้ากับเรา')}
            {renderLink('เกี่ยวกับเรา')}
          </div>
        </div>

        <div className='footer-col contact-col'>
          <h3 className='footer-heading'>ติดต่อเรา</h3>
          <div className='footer-contact-item support-item'>
            <img className="footer-icon" alt="support" src={ICON_SUPPORT} />
            <span className="font-weight-bold">Support Center</span>
          </div>
          <a href="mailto:contact@meyameya.me" className='footer-contact-item' style={{ textDecoration: 'none', color: 'inherit' }}>
            <img className="footer-icon" alt="email" src={ICON_MAIL} />
            <span>contact@meyameya.me</span>
          </a>
          <a href="tel:0979966908" className='footer-contact-item' style={{ textDecoration: 'none', color: 'inherit' }}>
            <img className="footer-icon" alt="phone" src={ICON_PHONE} />
            <span>097-996-6908</span>
          </a>
          <a href="https://line.me/R/ti/p/@meya" target="_blank" rel="noopener noreferrer" className='footer-contact-item' style={{ textDecoration: 'none', color: 'inherit' }}>
            <img className="footer-icon" alt="line" src={ICON_LINE} />
            <span>Line OA : @meya</span>
          </a>
        </div>

        <div className='footer-col address-col'>
          <h3 className='footer-heading'>ที่อยู่</h3>
          <a href="https://maps.app.goo.gl/RZnFHTWsWYyqC4VV9" target="_blank" rel="noopener noreferrer" className='footer-contact-item' style={{ textDecoration: 'none', color: 'inherit' }}>
            <img className="footer-icon" alt="pin" src={ICON_PIN} />
            <span>บริษัท มียามียา จำกัด</span>
          </a>
          <p className='footer-address-text'>
            233/77 Sanphawut Rd, South Bangna,<br />
            Bangna, Bangkok, Thailand 10260
          </p>
        </div>
      </div>

      <div className='footer-bottom'>
        <div className='copyright'>
          © {new Date().getFullYear()} Copyright : <span className="brand-highlight">MEYA</span>
        </div>
        <div className='footer-legal'>
          <span className='privacy-link'>Privacy Policy</span>
          <span className='separator'>|</span>
          <span className='terms-link'>Terms of Service</span>
        </div>
      </div>
    </footer>
  );
};

export default NewFooter;